export default __webpack_public_path__ + "static/media/secureleft.9fd18cee.svg";